export {default} from './RankName.connect';
